import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { CoverImage } from "./CoverImage";
import { CoverImageEvent } from "./CoverImageEvent";

export const Cover = () => {
  const { paywall } = usePaywallCheckoutContext();

  if (paywall.event) {
    return <CoverImageEvent />;
  }

  if (paywall?.paywall_customization?.cover_image) {
    return <CoverImage />;
  }

  return null;
};
